<template>
  <v-navigation-drawer
    v-model="drawer"
     absolute
    temporary
    color="#fff"
  >
    <v-list >
      <div v-for="item in isMenuItem(items)" :key="item.description">
        <v-list-group  :value="true">
          <template v-slot:activator>
            <v-list-item-icon class="list-icon" >
              <v-icon  color="rgba(0,0,0,.87)">{{
                item.imagePath
              }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="list-item" > {{ item.description }} </v-list-item-title>
          </template>
          <v-list-item
            v-for="child in isMenuItem(item.children)"
            :key="child.title"
            link
            :to="child.link"
            fill-height
            @click="handleRoute(child)"
          >
            <v-list-item-icon  class="list-icon">
              <v-icon>{{
                child.imagePath
              }}</v-icon>
            </v-list-item-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content>
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    @click="handleRoute(child)"
                    >{{ $t(child.description) }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
              <span>{{ $t(child.description) }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import NavigationMenu from "./mixin/NavigationMenu";

export default {
  mixins: [NavigationMenu]
};

    // <v-card tile  color="#1F88E5" height="48" elevation="0">
    //   <v-list-item class="px-2 h-48px" @click="toggleMini = !toggleMini">
    //     <v-list-item-avatar>
    //       <v-icon color="#fff">mdi-menu</v-icon>
    //     </v-list-item-avatar>

    //   </v-list-item>
    // </v-card>
</script>
<style lang="scss" scoped>
.h-100px {
  height: 100px;
}
.list-item {
  color: rgba(0,0,0,.87)!important
}
.list-icon {
  margin-right: 16px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/NavigationMenu.vue